import { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import { node, string, bool } from 'prop-types';

export default class WidgetPortal extends PureComponent {
    static propTypes = {
        children: node.isRequired,
        elementId: string,
        eraseContent: bool,
        /**
         * Selector of a container that needs to be cleare when the portal is active.
         * You can use it to avoid duplicate nodes in the DOM
         */
        clearElement: string,
    };

    static defaultProps = {
        elementId: null,
        eraseContent: false,
        clearElement: null,
    };

    constructor(props) {
        super(props);

        this.el =
            typeof document !== 'undefined' &&
            document.getElementById(this.props.elementId);
        const isRootRenderedBySomeReact = !!this.el?._reactRootContainer; // it's internal react data which we use to check if we are in local development of on manomano-sf
        if (this.el && this.props.eraseContent && !isRootRenderedBySomeReact) {
            this.el.innerHTML = '';
        }

        if (this.props.clearElement && typeof document !== 'undefined') {
            Array.from(
                document.querySelectorAll(this.props.clearElement),
            ).forEach(elem => {
                elem.innerHTML = '';
            });
        }
    }

    render() {
        if (this.el) {
            return createPortal(this.props.children, this.el);
        }
        return this.props.children;
    }
}
